import Vue from 'vue';
import axios from './router/axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router/router';
import './permission'; // 权限
import './error'; // 日志
import './cache';//页面缓存
import store from './store';
import { loadStyle } from './util/util'
import './assets/icon/iconfont.css';
import BaiduMap from 'vue-baidu-map'
import './assets/icon_1/iconfont.css';
import './util/rem.js'
import * as urls from '@/config/env';
import Element from 'element-ui';
import {
  iconfontUrl,
  iconfontVersion,
} from '@/config/env';
import i18n from './lang' // Internationalization
import './styles/common.scss';
//导入主题文件
// import '@/theme/index.js'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Vue.use(BaiduMap,{
  ak:'jRju2XXOGwDve9gwL0Epl09iam2ir52n'
})
Viewer.setDefaults({
  Options: {
  'inline': true,
  'button': true,
  'navbar': true,
  'title': true,
  'toolbar': true,
  'tooltip': true,
  'movable': true,
  'zoomable': true,
  'rotatable': true,
  'scalable': true,
  'transition': true,
  'fullscreen': true,
  'keyboard': true,
  'url': 'data-source'
  }
})

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// 二开  start 引入自定义指令
import directives from '@/directives'
Object.keys(directives).forEach(item => {
  Vue.directive(item, directives[item])
})
// 二开 end

import basicBlock from './components/basic-block/main'
import basicContainer from './components/basic-container/main'
import thirdRegister from './components/third-register/main'
import avueUeditor from 'avue-plugin-ueditor';
import website from '@/config/website';

import VueAMap from "vue-amap";
Vue.use(VueAMap);
Vue.prototype.$EvenBus = new Vue();
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: "efeb5f14e939aac9c4748abebfe95a36", // 这里写你申请的高德地图的key
  plugin: ["AMap.Autocomplete", "AMap.Geocoder", "AMap.Geolocation"],
  v: "1.4.15",
  uiVersion: "1.0.11"
});
import './assets/css/common.scss';
Vue.use(router);
Vue.use(VueAxios, axios);
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(window.AVUE, {
  size: 'small',
  tableSize: 'small',
  i18n: (key, value) => i18n.t(key, value)
});

import {
  url
} from '@/config'
window.socketName = ''
//注册全局容器
Vue.component('basicContainer', basicContainer);
Vue.component('basicBlock', basicBlock);
Vue.component('thirdRegister', thirdRegister);
Vue.component('avueUeditor', avueUeditor);
// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key];
});
// 加载website
Vue.prototype.website = website;
// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
  loadStyle(iconfontUrl.replace('$key', ele));
});


if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}
Vue.config.productionTip = false;
Vue.prototype.url = url;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

